import React from 'react';

const CustomSwitch = ({ checked, onChange, disabled }) => {
    return (
        <label className="custom-switch">
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
            <span className="slider round"></span>
        </label>
    );
};

export default CustomSwitch;
